module.exports = __webpack_public_path__ + "media/images/flags/KP-3170f95dc95a98a8cbf1f26110ee6221.svg";